var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-popover', {
    attrs: {
      "placement": "bottom-end",
      "width": "300"
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "download-report"
  }, [_c('p', [_vm._v(_vm._s(_vm.title))]), _c('el-date-picker', {
    staticClass: "el-date-editor_filter",
    attrs: {
      "type": "daterange",
      "format": "dd.MM.yyyy",
      "value-format": "yyyy-MM-dd",
      "start-placeholder": "От",
      "end-placeholder": "До"
    },
    model: {
      value: _vm.reportDates,
      callback: function callback($$v) {
        _vm.reportDates = $$v;
      },
      expression: "reportDates"
    }
  }), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleCurrentChange
    }
  }, [_vm._v(" Скачать ")])], 1), _vm.textButton ? _c('el-button', {
    attrs: {
      "slot": "reference",
      "size": "small"
    },
    slot: "reference"
  }, [_vm._v(" " + _vm._s(_vm.textButton) + " ")]) : _c('el-button', {
    staticClass: "download-report__button",
    attrs: {
      "slot": "reference",
      "icon": "el-icon-download",
      "size": "small"
    },
    slot: "reference"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }